module.exports = __webpack_public_path__ + "static/right_girl-4373110d4e051c9e894a7c597ae7fd47.png";